/*
  «Скоро» + «Напомнить»: таймер до старта продаж и поп-ап подписки на SMS.
  Шаги поп-апа: имя и телефон → «номер верный?» → код из SMS → готово.
  Если номер уже подтверждён раньше — без кода. Если SMS не приходит — e-mail.
  Бэкенд: вебхуки n8n (send-code, verify-code, email). Настройки — в #MkNotifyConfig.
*/
(function () {
  'use strict';

  var cfgEl = document.getElementById('MkNotifyConfig');
  var soonEl = document.querySelector('[data-mk-soon]');
  if (!cfgEl || !soonEl) return;

  var CFG = {};
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var LANG = CFG.lang === 'en' ? 'en' : 'ru';
  var API = CFG.api;
  var PRODUCT = CFG.product || {};
  var STORE_KEY = 'mk_notify_' + PRODUCT.handle;
  var RESEND_SECONDS = 75;

  var I18N = {
    ru: {
      title: 'Напомнить о старте продаж',
      sub: 'Пришлём SMS, когда «{p}» появится в продаже.',
      name: 'Ваше имя',
      search: 'Поиск страны',
      consent: 'Хочу получить SMS о старте продаж. Даю согласие EU RESERVE sp. z o.o. на обработку имени и номера по <a href="{u}" target="_blank" rel="noopener">Политике конфиденциальности</a> — отозвать его можно в любой момент.',
      marketing: 'Хочу также получать SMS о новинках и концертах.',
      more: 'ещё',
      less: 'свернуть',
      next: 'Продолжить',
      confirmQ: 'Номер введён верно?',
      edit: 'Изменить',
      yes: 'Да, продолжить',
      codeTitle: 'Введите код из SMS',
      codeSub: 'Отправили код на номер',
      editPhone: 'Изменить номер',
      verify: 'Подтвердить',
      resendIn: 'Отправить ещё раз можно через',
      resend: 'Отправить ещё раз',
      noSms: 'Не пришёл код?',
      resent: 'Код отправлен ещё раз.',
      emailTitle: 'SMS не приходит?',
      emailSub: 'Оставьте e-mail — напомним письмом, когда товар появится в продаже.',
      emailPh: 'E-mail',
      save: 'Сохранить',
      backSms: 'Попробовать по SMS ещё раз',
      close: 'Закрыть',
      sending: 'Отправка…',
      doneTitle: 'Готово!',
      doneSms: 'Пришлём SMS, когда «{p}» появится в продаже.',
      doneEmail: 'Напомним письмом на {e}, когда «{p}» появится в продаже.',
      inBaseTitle: 'Вы уже в базе',
      inBaseAdded: 'Номер уже подтверждён — добавили напоминание и об этом товаре.',
      inBaseSame: 'Мы уже напомним вам об этом товаре.',
      btnDone: 'Напомним',
      days: 'дн',
      at: 'в',
      start: 'Старт продаж',
      err: {
        fill: 'Заполните имя, номер и отметьте согласие.',
        name: 'Укажите имя.',
        phone: 'Проверьте номер телефона.',
        mobile: 'Нужен мобильный номер — на него придёт SMS.',
        consent: 'Отметьте согласие на получение SMS.',
        code6: 'Введите 6 цифр из SMS.',
        email: 'Проверьте e-mail.',
        invalid_phone: 'Проверьте номер телефона.',
        too_many_requests: 'Код уже отправлен недавно — подождите немного.',
        sms_send_failed: 'Не удалось отправить SMS. Попробуйте ещё раз.',
        not_requested: 'Сначала запросите код.',
        expired: 'Код устарел — отправьте новый.',
        too_many_attempts: 'Слишком много попыток — отправьте новый код.',
        wrong_code: 'Неверный код, попробуйте ещё раз.',
        invalid_email: 'Проверьте e-mail.',
        bad_request: 'Проверьте данные и попробуйте ещё раз.',
        server_error: 'Что-то пошло не так. Попробуйте ещё раз.',
        network: 'Нет связи. Проверьте интернет и попробуйте ещё раз.'
      }
    },
    en: {
      title: 'Remind me when it drops',
      sub: 'We’ll text you when “{p}” goes on sale.',
      name: 'Your name',
      search: 'Search country',
      consent: 'Text me when sales start. I consent to EU RESERVE sp. z o.o. processing my name and number under the <a href="{u}" target="_blank" rel="noopener">Privacy Policy</a> — I can withdraw it at any time.',
      marketing: 'Also text me about new merch and concerts.',
      more: 'more',
      less: 'less',
      next: 'Continue',
      confirmQ: 'Is this number correct?',
      edit: 'Change',
      yes: 'Yes, continue',
      codeTitle: 'Enter the SMS code',
      codeSub: 'We sent a code to',
      editPhone: 'Change number',
      verify: 'Confirm',
      resendIn: 'You can resend in',
      resend: 'Send again',
      noSms: 'No code?',
      resent: 'Code sent again.',
      emailTitle: 'SMS not arriving?',
      emailSub: 'Leave your e-mail and we’ll remind you when the item goes on sale.',
      emailPh: 'E-mail',
      save: 'Save',
      backSms: 'Try SMS again',
      close: 'Close',
      sending: 'Sending…',
      doneTitle: 'Done!',
      doneSms: 'We’ll text you when “{p}” goes on sale.',
      doneEmail: 'We’ll e-mail {e} when “{p}” goes on sale.',
      inBaseTitle: 'You’re already on the list',
      inBaseAdded: 'Your number is already verified — we added a reminder for this item too.',
      inBaseSame: 'We’ll already remind you about this item.',
      btnDone: 'Reminder on',
      days: 'd',
      at: 'at',
      start: 'Sales start',
      err: {
        fill: 'Enter your name and number and tick the consent.',
        name: 'Enter your name.',
        phone: 'Check the phone number.',
        mobile: 'Please use a mobile number — the SMS goes there.',
        consent: 'Tick the consent to receive SMS.',
        code6: 'Enter the 6 digits from the SMS.',
        email: 'Check the e-mail.',
        invalid_phone: 'Check the phone number.',
        too_many_requests: 'A code was sent recently — please wait a bit.',
        sms_send_failed: 'Could not send the SMS. Please try again.',
        not_requested: 'Request a code first.',
        expired: 'The code has expired — send a new one.',
        too_many_attempts: 'Too many attempts — send a new code.',
        wrong_code: 'Wrong code, please try again.',
        invalid_email: 'Check the e-mail.',
        bad_request: 'Check the details and try again.',
        server_error: 'Something went wrong. Please try again.',
        network: 'No connection. Check your internet and try again.'
      }
    }
  };
  var T = I18N[LANG];

  function fmt(s, vars) {
    return String(s).replace(/\{(\w)\}/g, function (_, k) { return vars && vars[k] != null ? vars[k] : ''; });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  /* ---------------- Таймер до старта продаж ---------------- */

  var releaseMs = Number(soonEl.getAttribute('data-release-ms')) || 0;

  function openSales() {
    // Время пришло: показываем обычные кнопки покупки и убираем блок «Скоро».
    var form = document.querySelector('[data-mk-soon-form]');
    if (form) form.style.display = '';
    var hide = document.getElementById('MkSoonHide');
    if (hide) hide.parentNode.removeChild(hide);
    if (soonEl.parentNode) soonEl.parentNode.removeChild(soonEl);
    document.querySelectorAll('.mk-soon-badge').forEach(function (b) { b.parentNode && b.parentNode.removeChild(b); });
  }

  if (releaseMs) {
    var dateEl = soonEl.querySelector('[data-mk-date]');
    if (dateEl) {
      try {
        var d = new Date(releaseMs);
        var loc = LANG === 'en' ? 'en-GB' : 'ru-RU';
        var day = new Intl.DateTimeFormat(loc, { day: 'numeric', month: 'long' }).format(d);
        var time = new Intl.DateTimeFormat(loc, { hour: '2-digit', minute: '2-digit' }).format(d);
        dateEl.textContent = T.start + ': ' + day + ' ' + T.at + ' ' + time;
      } catch (e) { /* без даты — не страшно */ }
    }
    var cellD = soonEl.querySelector('[data-mk-cell="d"]');
    var bD = cellD && cellD.querySelector('b');
    var bH = soonEl.querySelector('[data-h]');
    var bM = soonEl.querySelector('[data-m]');
    var bS = soonEl.querySelector('[data-s]');
    var tick = function () {
      var diff = releaseMs - Date.now();
      if (diff <= 0) { openSales(); return; }
      var s = Math.floor(diff / 1000);
      var days = Math.floor(s / 86400); s -= days * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      if (cellD) cellD.style.display = days > 0 ? '' : 'none';
      if (bD) bD.textContent = days;
      if (bH) bH.textContent = pad(h);
      if (bM) bM.textContent = pad(m);
      if (bS) bS.textContent = pad(s);
      setTimeout(tick, 1000 - (Date.now() % 1000) + 5);
    };
    tick();
  }

  /* ---------------- Кнопка «Напомнить» ---------------- */

  var openBtn = soonEl.querySelector('[data-mk-open]');
  var btnLabel = soonEl.querySelector('[data-mk-btn-label]');
  function markButtonDone() {
    if (btnLabel) btnLabel.textContent = T.btnDone + ' ✓';
    if (openBtn) openBtn.classList.add('is-done');
  }
  try { if (localStorage.getItem(STORE_KEY)) markButtonDone(); } catch (e) {}

  /* ---------------- UTM / откуда пришёл ---------------- */

  function getUtm() {
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    var out = {};
    var params = new URLSearchParams(location.search);
    var fromUrl = keys.some(function (k) { return params.get(k); });
    if (fromUrl) {
      keys.forEach(function (k) { out[k] = params.get(k) || ''; });
      return out;
    }
    try {
      var saved = JSON.parse(localStorage.getItem('mk_utm') || 'null');
      if (saved && saved.t && Date.now() - saved.t < 30 * 864e5) {
        keys.forEach(function (k) { out[k] = saved[k] || ''; });
        return out;
      }
    } catch (e) {}
    keys.forEach(function (k) { out[k] = ''; });
    return out;
  }
  function firstReferrer() {
    try {
      var saved = JSON.parse(localStorage.getItem('mk_utm') || 'null');
      if (saved && saved.ref) return saved.ref;
    } catch (e) {}
    return document.referrer || '';
  }

  /* ---------------- Поп-ап ---------------- */

  var modal = null;
  var els = {};
  var state = { e164: '', pretty: '', name: '', country: '', resends: 0, timer: null, lastFocus: null };

  /* Фокус без прокрутки страницы. И пока поп-ап открыт, страница под ним стоит на месте:
     запоминаем, где она была, и возвращаем туда, если браузер её сдвинул (Safari сдвигает
     страницу при фокусе на поле в поп-апе — после закрытия товар «прилипал» к меню). */
  var FS = { preventScroll: true };
  var lockY = 0;
  function jumpTo(y) {
    var h = document.documentElement;
    var prev = h.style.scrollBehavior;
    h.style.scrollBehavior = 'auto';
    window.scrollTo(0, y);
    h.style.scrollBehavior = prev;
  }
  function keepScroll() {
    if (!document.documentElement.classList.contains('mk-lock')) return;
    if (Math.abs((window.pageYOffset || 0) - lockY) > 1) jumpTo(lockY);
  }

  function build() {
    var p = esc(PRODUCT.title);
    var html =
      '<div class="mk-modal__backdrop" data-close></div>' +
      '<div class="mk-modal__card" role="dialog" aria-modal="true" aria-labelledby="MkTitle">' +
        '<button type="button" class="mk-modal__x" data-close aria-label="' + esc(T.close) + '">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
        '</button>' +

        '<section class="mk-step" data-step="form">' +
          '<div class="mk-h" id="MkTitle">' + esc(T.title) + '</div>' +
          '<p class="mk-sub">' + fmt(esc(T.sub), { p: p }) + '</p>' +
          '<input class="mk-input" data-name type="text" autocomplete="given-name" maxlength="80" placeholder="' + esc(T.name) + '">' +
          '<div class="mk-phone">' +
            '<button type="button" class="mk-country" data-country aria-haspopup="listbox" aria-expanded="false">' +
              '<span class="mk-flag" data-flag></span><span data-dial></span>' +
              '<svg width="10" height="6" viewBox="0 0 10 6" aria-hidden="true"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round"/></svg>' +
            '</button>' +
            '<input class="mk-input" data-phone type="tel" inputmode="tel" autocomplete="tel-national" maxlength="22">' +
            '<div class="mk-clist" data-clist hidden>' +
              '<input class="mk-input mk-clist__search" data-csearch type="text" autocomplete="off" placeholder="' + esc(T.search) + '">' +
              '<ul role="listbox" data-citems></ul>' +
            '</div>' +
          '</div>' +
          '<label class="mk-check"><input type="checkbox" data-consent><span class="mk-check__text"><span class="mk-clamp">' + fmt(T.consent, { u: esc(CFG.privacyUrl || '/policies/privacy-policy') }) + '</span>' + moreBtn() + '</span></label>' +
          '<label class="mk-check"><input type="checkbox" data-marketing><span class="mk-check__text"><span class="mk-clamp">' + esc(T.marketing) + '</span>' + moreBtn() + '</span></label>' +
          '<div class="mk-err" data-err aria-live="polite"></div>' +
          '<button type="button" class="mk-pill" data-act="toConfirm">' + esc(T.next) + '</button>' +
        '</section>' +

        '<section class="mk-step" data-step="confirm" hidden>' +
          '<div class="mk-bignum" data-num></div>' +
          '<p class="mk-sub">' + esc(T.confirmQ) + '</p>' +
          '<button type="button" class="mk-link" data-act="edit">' + esc(T.edit) + '</button>' +
          '<div class="mk-err" data-err aria-live="polite"></div>' +
          '<button type="button" class="mk-pill" data-act="send">' + esc(T.yes) + '</button>' +
        '</section>' +

        '<section class="mk-step" data-step="code" hidden>' +
          '<div class="mk-h">' + esc(T.codeTitle) + '</div>' +
          '<p class="mk-sub">' + esc(T.codeSub) + '<br><b class="mk-num" data-num></b></p>' +
          '<button type="button" class="mk-link" data-act="edit">' + esc(T.editPhone) + '</button>' +
          '<div class="mk-code" data-code>' +
            '<input class="mk-digit" type="text" inputmode="numeric" autocomplete="one-time-code" maxlength="6" aria-label="1">' +
            '<input class="mk-digit" type="text" inputmode="numeric" maxlength="1" aria-label="2">' +
            '<input class="mk-digit" type="text" inputmode="numeric" maxlength="1" aria-label="3">' +
            '<input class="mk-digit" type="text" inputmode="numeric" maxlength="1" aria-label="4">' +
            '<input class="mk-digit" type="text" inputmode="numeric" maxlength="1" aria-label="5">' +
            '<input class="mk-digit" type="text" inputmode="numeric" maxlength="1" aria-label="6">' +
          '</div>' +
          '<div class="mk-err" data-err aria-live="polite"></div>' +
          '<button type="button" class="mk-pill" data-act="verify">' + esc(T.verify) + '</button>' +
          '<p class="mk-resend">' + esc(T.noSms) + ' ' +
            '<span data-wait>' + esc(T.resendIn) + ' <b data-left>01:15</b></span>' +
            '<button type="button" class="mk-link mk-link--inline" data-act="resend" hidden>' + esc(T.resend) + '</button>' +
          '</p>' +
        '</section>' +

        '<section class="mk-step" data-step="email" hidden>' +
          '<div class="mk-h">' + esc(T.emailTitle) + '</div>' +
          '<p class="mk-sub">' + esc(T.emailSub) + '</p>' +
          '<input class="mk-input" data-email type="email" inputmode="email" autocomplete="email" maxlength="120" placeholder="' + esc(T.emailPh) + '">' +
          '<div class="mk-err" data-err aria-live="polite"></div>' +
          '<button type="button" class="mk-pill" data-act="email">' + esc(T.save) + '</button>' +
          '<button type="button" class="mk-link" data-act="backSms">' + esc(T.backSms) + '</button>' +
        '</section>' +

        '<section class="mk-step mk-step--done" data-step="done" hidden>' +
          '<div class="mk-done-icon" aria-hidden="true"><svg width="28" height="28" viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2.4" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></div>' +
          '<div class="mk-h" data-done-title></div>' +
          '<p class="mk-sub" data-done-text></p>' +
          '<button type="button" class="mk-pill" data-close>' + esc(T.close) + '</button>' +
        '</section>' +
      '</div>';

    modal = document.createElement('div');
    modal.className = 'mk-modal';
    modal.hidden = true;
    modal.innerHTML = html;
    document.body.appendChild(modal);

    els.steps = {};
    modal.querySelectorAll('[data-step]').forEach(function (s) { els.steps[s.getAttribute('data-step')] = s; });
    els.name = modal.querySelector('[data-name]');
    els.phone = modal.querySelector('[data-phone]');
    els.countryBtn = modal.querySelector('[data-country]');
    els.flag = modal.querySelector('[data-flag]');
    els.dial = modal.querySelector('[data-dial]');
    els.clist = modal.querySelector('[data-clist]');
    els.csearch = modal.querySelector('[data-csearch]');
    els.citems = modal.querySelector('[data-citems]');
    els.consent = modal.querySelector('[data-consent]');
    els.marketing = modal.querySelector('[data-marketing]');
    els.email = modal.querySelector('[data-email]');
    els.digits = Array.prototype.slice.call(modal.querySelectorAll('.mk-digit'));
    els.wait = modal.querySelector('[data-wait]');
    els.left = modal.querySelector('[data-left]');
    els.resendBtn = modal.querySelector('[data-act="resend"]');

    modal.addEventListener('click', onClick);
    modal.addEventListener('keydown', onKeydown);
    els.phone.addEventListener('input', onPhoneInput);
    els.csearch.addEventListener('input', renderCountries);
    [els.name, els.phone].forEach(function (i) { i.addEventListener('input', function () { i.classList.remove('has-error'); }); });
    els.consent.addEventListener('change', function () { els.consent.closest('.mk-check').classList.remove('has-error'); });
    setupDigits();
    setCountry(pickDefaultCountry());
  }

  function show(step) {
    Object.keys(els.steps).forEach(function (k) { els.steps[k].hidden = k !== step; });
    var err = els.steps[step].querySelector('[data-err]');
    if (err) { err.textContent = ''; err.classList.remove('is-ok'); }
    var focusEl = {
      form: els.name.value ? els.phone : els.name,
      code: els.digits[0],
      email: els.email
    }[step];
    if (focusEl && window.matchMedia('(hover: hover)').matches) setTimeout(function () { focusEl.focus(FS); }, 30);
  }

  function setError(step, msg, ok) {
    var err = els.steps[step].querySelector('[data-err]');
    if (!err) return;
    err.textContent = msg || '';
    err.classList.toggle('is-ok', !!ok);
  }

  function open() {
    if (!modal) build();
    state.lastFocus = document.activeElement;
    lockY = window.pageYOffset || document.documentElement.scrollTop || 0;
    toggleCountries(false);
    modal.hidden = false;
    document.documentElement.classList.add('mk-lock');
    window.addEventListener('scroll', keepScroll, { passive: true });
    var card = modal.querySelector('.mk-modal__card');
    if (card) card.scrollTop = 0;
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    // если человек ждёт код или вводит e-mail — продолжаем с того же места, иначе с начала
    if (els.steps.code.hidden && els.steps.email.hidden) show('form');
    requestAnimationFrame(function () { requestAnimationFrame(checkClamps); });
  }

  /* Длинные тексты согласий — две строки и «ещё» */
  function moreBtn() { return '<button type="button" class="mk-more" data-more hidden>' + esc(T.more) + '</button>'; }
  function checkClamps() {
    if (!modal) return;
    modal.querySelectorAll('.mk-clamp').forEach(function (c) {
      var btn = c.parentNode.querySelector('[data-more]');
      if (!btn || c.classList.contains('is-open')) return;
      btn.hidden = c.scrollHeight <= c.clientHeight + 2;
    });
  }
  function toggleMore(btn) {
    var c = btn.parentNode.querySelector('.mk-clamp');
    if (!c) return;
    var opened = c.classList.toggle('is-open');
    btn.textContent = opened ? T.less : T.more;
  }

  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    window.removeEventListener('scroll', keepScroll);
    document.documentElement.classList.remove('mk-lock');
    if (Math.abs((window.pageYOffset || 0) - lockY) > 1) jumpTo(lockY);
    setTimeout(function () { modal.hidden = true; toggleCountries(false); }, 180);
    if (state.lastFocus && state.lastFocus.focus) state.lastFocus.focus(FS);
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      if (!els.clist.hidden) { toggleCountries(false); return; }
      close();
    }
    if (e.key === 'Enter' && e.target.tagName === 'INPUT' && e.target.type !== 'checkbox') {
      var step = e.target.closest('[data-step]');
      var btn = step && step.querySelector('.mk-pill');
      if (btn && e.target !== els.csearch) { e.preventDefault(); btn.click(); }
    }
  }

  function onClick(e) {
    var t = e.target;
    var more = t.closest('[data-more]');
    if (more) { e.preventDefault(); toggleMore(more); return; }
    if (t.closest('[data-close]')) { close(); return; }
    if (t.closest('[data-country]')) { toggleCountries(els.clist.hidden); return; }
    var item = t.closest('[data-iso]');
    if (item) { setCountry(item.getAttribute('data-iso')); toggleCountries(false); onPhoneInput(); els.phone.focus(FS); return; }
    if (!t.closest('[data-clist]') && els.clist && !els.clist.hidden) toggleCountries(false);
    var act = t.closest('[data-act]');
    if (!act) return;
    var a = act.getAttribute('data-act');
    if (a === 'toConfirm') toConfirm();
    else if (a === 'edit') { stopTimer(); show('form'); }
    else if (a === 'send') sendCode(act, 'confirm');
    else if (a === 'verify') verify(act);
    else if (a === 'resend') resend(act);
    else if (a === 'email') saveEmail(act);
    else if (a === 'backSms') { state.resends = 0; show('code'); startTimer(); }
  }

  /* ---------- Телефон и страны (libphonenumber-js) ---------- */

  function lib() { return window.libphonenumber || null; }

  var FALLBACK_DIAL = { PL: '48', DE: '49', CZ: '420', SK: '421', LT: '370', LV: '371', EE: '372', UA: '380', GB: '44', AT: '43', NL: '31', BE: '32', FR: '33', IT: '39', ES: '34', IE: '353', SE: '46', NO: '47', FI: '358', DK: '45', CH: '41', PT: '351', US: '1', CA: '1', IL: '972', GE: '995', KZ: '7', MD: '373', RO: '40', HU: '36', BG: '359', HR: '385', SI: '386', GR: '30', LU: '352', CY: '357', MT: '356' };

  function flagOf(iso) {
    try { return iso.toUpperCase().replace(/./g, function (c) { return String.fromCodePoint(c.charCodeAt(0) + 127397); }); } catch (e) { return ''; }
  }
  function dialOf(iso) {
    var L = lib();
    try { if (L && L.getCountryCallingCode) return String(L.getCountryCallingCode(iso)); } catch (e) {}
    return FALLBACK_DIAL[iso] || '';
  }
  function countryName(iso) {
    try { return new Intl.DisplayNames([LANG], { type: 'region' }).of(iso); } catch (e) { return iso; }
  }
  function allCountries() {
    var L = lib();
    var list = (L && L.getCountries) ? L.getCountries() : Object.keys(FALLBACK_DIAL);
    return list.filter(function (iso) { return iso.length === 2 && dialOf(iso); });
  }
  function pickDefaultCountry() {
    var c = (CFG.country || '').toUpperCase();
    return dialOf(c) ? c : 'PL';
  }
  function setCountry(iso) {
    state.country = iso;
    els.flag.textContent = flagOf(iso);
    els.dial.textContent = '+' + dialOf(iso);
    els.phone.placeholder = examplePlaceholder(iso);
  }
  var EXAMPLES = { PL: '512 345 678', DE: '01512 3456789', CZ: '601 123 456', SK: '0912 123 456', GB: '07400 123456', UA: '050 123 4567', LT: '8 612 34567', LV: '21 234 567', EE: '5123 4567', NL: '06 12345678', AT: '0664 123456', FR: '06 12 34 56 78', IT: '312 345 6789', ES: '612 34 56 78', IE: '085 012 3456', US: '(201) 555-0123', CA: '(506) 234-5678' };
  function examplePlaceholder(iso) { return EXAMPLES[iso] || ''; }

  function parse(raw, iso) {
    var L = lib();
    if (!L) return null;
    var fn = L.parsePhoneNumberFromString || L.parsePhoneNumber;
    try { return iso ? fn(raw, iso) : fn(raw); } catch (e) { return null; }
  }
  var PRIORITY = ['PL', 'DE', 'CZ', 'LT', 'LV', 'EE', 'UA', 'GB', 'NL', 'AT', 'FR', 'IT', 'ES', 'IE', 'SE', 'NO', 'FI', 'DK', 'SK', 'US', 'CA', 'IL', 'GE', 'KZ', 'MD'];
  function renderCountries() {
    var q = (els.csearch.value || '').trim().toLowerCase();
    var list = allCountries().map(function (iso) { return { iso: iso, name: countryName(iso) || iso, dial: dialOf(iso) }; });
    list.sort(function (a, b) {
      var pa = PRIORITY.indexOf(a.iso), pb = PRIORITY.indexOf(b.iso);
      if (a.iso === pickDefaultCountry()) return -1;
      if (b.iso === pickDefaultCountry()) return 1;
      if (pa !== -1 || pb !== -1) return (pa === -1 ? 999 : pa) - (pb === -1 ? 999 : pb);
      return a.name.localeCompare(b.name, LANG);
    });
    if (q) {
      var qd = q.replace(/^\+/, '');
      list = list.filter(function (c) { return c.name.toLowerCase().indexOf(q) !== -1 || c.iso.toLowerCase() === q || c.dial.indexOf(qd) === 0; });
    }
    els.citems.innerHTML = list.map(function (c) {
      return '<li role="option" data-iso="' + c.iso + '"' + (c.iso === state.country ? ' aria-selected="true"' : '') + '>' +
        '<span class="mk-flag">' + flagOf(c.iso) + '</span><span class="mk-cname">' + esc(c.name) + '</span><span class="mk-cdial">+' + c.dial + '</span></li>';
    }).join('');
  }
  function toggleCountries(openList) {
    els.clist.hidden = !openList;
    els.countryBtn.setAttribute('aria-expanded', openList ? 'true' : 'false');
    if (openList) { els.csearch.value = ''; renderCountries(); if (window.matchMedia('(hover: hover)').matches) els.csearch.focus(FS); }
  }

  /* Не даём ввести лишние цифры. Предел — самая длинная мобильная длина номера в стране
     (Польша — 9 цифр, Германия — 11, плюс «0» в начале, если его ввели), по данным libphonenumber.
     Без библиотеки — не больше 15 цифр (предел международного формата). */
  function maxMobileLength(iso) {
    var L = lib();
    try {
      var m = new L.Metadata();
      m.selectNumberingPlan(iso);
      var t = m.numberingPlan.type('MOBILE');
      var lens = t && t.possibleLengths();
      if (lens && lens.length) return Math.max.apply(null, lens);
    } catch (e) {}
    return 0;
  }
  function fitLength(digits, iso) {
    var L = lib();
    if (L && L.AsYouType) {
      try {
        while (digits.length > 1) {
          var a = new L.AsYouType(iso || undefined);
          a.input(iso ? digits : '+' + digits);
          var country = iso || (a.getCountry && a.getCountry());
          var max = country ? maxMobileLength(country) : 0;
          var nsn = a.getNationalNumber ? a.getNationalNumber() : '';
          var tooLong = max
            ? nsn.length > max
            : (typeof L.validatePhoneNumberLength === 'function' && L.validatePhoneNumberLength(iso ? digits : '+' + digits, iso) === 'TOO_LONG');
          if (!tooLong) break;
          digits = digits.slice(0, -1);
        }
      } catch (e) {}
    }
    return digits.slice(0, 15);
  }

  function onPhoneInput() {
    var L = lib();
    var v = els.phone.value;
    // вставили номер целиком с +код страны — определяем страну сами
    if (/^\s*(\+|00)/.test(v)) {
      var raw = v.replace(/^\s*00/, '').replace(/\D/g, '');
      var d = fitLength(raw);
      var p = L ? parse('+' + d) : null;
      if (p && p.country) {
        setCountry(p.country);
        els.phone.value = p.formatNational();
        return;
      }
      if (d.length < raw.length) els.phone.value = '+' + d;
      return;
    }
    var digits = fitLength(v.replace(/\D/g, ''), state.country);
    var formatted = (L && L.AsYouType) ? new L.AsYouType(state.country).input(digits) : digits;
    if (formatted !== v) els.phone.value = formatted;
  }

  function readPhone() {
    var L = lib();
    var raw = els.phone.value.trim();
    var digits = raw.replace(/\D/g, '');
    if (!digits) return { ok: false, reason: 'phone' };
    if (L && (L.parsePhoneNumberFromString || L.parsePhoneNumber)) {
      var p = /^\s*(\+|00)/.test(raw)
        ? parse(raw.replace(/^\s*00/, '+'))
        : parse(digits, state.country);
      if (!p || !p.isValid()) return { ok: false, reason: 'phone' };
      var type = p.getType ? p.getType() : undefined;
      if (type === 'FIXED_LINE' || type === 'TOLL_FREE' || type === 'PREMIUM_RATE' || type === 'SHARED_COST') return { ok: false, reason: 'mobile' };
      return { ok: true, e164: p.number, pretty: p.formatInternational() };
    }
    // без библиотеки — простая проверка длины
    var dial = dialOf(state.country);
    var nat = digits.replace(/^0+/, '');
    if (nat.length < 6 || nat.length > 13) return { ok: false, reason: 'phone' };
    return { ok: true, e164: '+' + dial + nat, pretty: '+' + dial + ' ' + els.phone.value.trim() };
  }

  /* ---------- Шаги ---------- */

  function toConfirm() {
    var name = els.name.value.trim();
    var phone = readPhone();
    var consentOk = els.consent.checked;
    els.name.classList.toggle('has-error', !name);
    els.phone.classList.toggle('has-error', !phone.ok);
    els.consent.closest('.mk-check').classList.toggle('has-error', !consentOk);
    if (!name || !phone.ok || !consentOk) {
      var msg = (!name && !phone.ok) || (!consentOk && (!name || !phone.ok)) ? T.err.fill
        : !name ? T.err.name
        : !phone.ok ? T.err[phone.reason]
        : T.err.consent;
      setError('form', msg);
      return;
    }
    state.name = name;
    state.e164 = phone.e164;
    state.pretty = phone.pretty;
    modal.querySelectorAll('[data-num]').forEach(function (n) { n.textContent = state.pretty; });
    show('confirm');
  }

  function payload(extra) {
    var utm = getUtm();
    var body = {
      phone: state.e164,
      name: state.name,
      lang: LANG,
      product_id: String(PRODUCT.id || ''),
      product_handle: PRODUCT.handle || '',
      product_title: PRODUCT.title || '',
      consent_required: !!els.consent.checked,
      consent_marketing: !!els.marketing.checked,
      page_url: location.href,
      referrer: firstReferrer(),
      utm_source: utm.utm_source,
      utm_medium: utm.utm_medium,
      utm_campaign: utm.utm_campaign,
      utm_content: utm.utm_content,
      utm_term: utm.utm_term
    };
    if (extra) Object.keys(extra).forEach(function (k) { body[k] = extra[k]; });
    return body;
  }

  function post(path, body) {
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 20000) : null;
    return fetch(API + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) {
      return r.json().catch(function () { return { ok: false, error: 'server_error' }; });
    }).catch(function () {
      return { ok: false, error: 'network' };
    }).then(function (res) {
      if (timer) clearTimeout(timer);
      return res || { ok: false, error: 'server_error' };
    });
  }

  function busy(btn, on) {
    if (!btn) return;
    if (on) {
      btn.dataset.label = btn.textContent;
      btn.textContent = T.sending;
      btn.disabled = true;
    } else {
      btn.textContent = btn.dataset.label || btn.textContent;
      btn.disabled = false;
    }
  }

  function errText(code) { return T.err[code] || T.err.server_error; }

  function done(kind, email) {
    stopTimer();
    var title = els.steps.done.querySelector('[data-done-title]');
    var text = els.steps.done.querySelector('[data-done-text]');
    var p = PRODUCT.title || '';
    if (kind === 'added') { title.textContent = T.inBaseTitle; text.textContent = T.inBaseAdded; }
    else if (kind === 'already_subscribed') { title.textContent = T.inBaseTitle; text.textContent = T.inBaseSame; }
    else if (kind === 'email') { title.textContent = T.doneTitle; text.textContent = fmt(T.doneEmail, { e: email, p: p }); }
    else { title.textContent = T.doneTitle; text.textContent = fmt(T.doneSms, { p: p }); }
    try { localStorage.setItem(STORE_KEY, String(Date.now())); } catch (e) {}
    markButtonDone();
    show('done');
  }

  function handleSendResult(res, stepForErrors) {
    if (res.ok && (res.status === 'added' || res.status === 'already_subscribed')) { done(res.status); return; }
    if (res.ok && res.status === 'code_sent') {
      clearDigits();
      if (stepForErrors === 'code') setError('code', T.resent, true);
      else show('code');
      startTimer();
      return;
    }
    setError(stepForErrors, errText(res.error));
  }

  function sendCode(btn, step) {
    busy(btn, true);
    post('send-code', payload()).then(function (res) {
      busy(btn, false);
      handleSendResult(res, step);
    });
  }

  function resend(btn) {
    state.resends += 1;
    if (state.resends >= 2) {
      stopTimer();
      show('email');
      return;
    }
    setError('code', '');
    busy(btn, true);
    post('send-code', payload()).then(function (res) {
      busy(btn, false);
      handleSendResult(res, 'code');
    });
  }

  function codeValue() { return els.digits.map(function (i) { return i.value; }).join('').replace(/\D/g, ''); }
  function clearDigits() { els.digits.forEach(function (i) { i.value = ''; }); els.steps.code.querySelector('[data-code]').classList.remove('has-error'); }

  function verify(btn) {
    if (btn && btn.disabled) return;
    var code = codeValue();
    var box = els.steps.code.querySelector('[data-code]');
    if (code.length !== 6) { box.classList.add('has-error'); setError('code', T.err.code6); return; }
    box.classList.remove('has-error');
    busy(btn, true);
    post('verify-code', payload({ code: code })).then(function (res) {
      busy(btn, false);
      if (res.ok && res.status === 'already_subscribed') { done('already_subscribed'); return; }
      if (res.ok) { done('subscribed'); return; }
      box.classList.add('has-error');
      setError('code', errText(res.error));
      if (res.error === 'wrong_code') { clearDigits(); box.classList.add('has-error'); els.digits[0].focus(FS); }
    });
  }

  function saveEmail(btn) {
    var email = els.email.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { els.email.classList.add('has-error'); setError('email', T.err.email); return; }
    els.email.classList.remove('has-error');
    busy(btn, true);
    post('email', payload({ email: email })).then(function (res) {
      busy(btn, false);
      if (res.ok) { done('email', email); return; }
      setError('email', errText(res.error));
    });
  }

  /* ---------- Таймер повторной отправки ---------- */

  function startTimer() {
    stopTimer();
    var left = RESEND_SECONDS;
    els.resendBtn.hidden = true;
    els.wait.hidden = false;
    var render = function () { els.left.textContent = pad(Math.floor(left / 60)) + ':' + pad(left % 60); };
    render();
    state.timer = setInterval(function () {
      left -= 1;
      if (left <= 0) { stopTimer(); els.wait.hidden = true; els.resendBtn.hidden = false; return; }
      render();
    }, 1000);
  }
  function stopTimer() { if (state.timer) { clearInterval(state.timer); state.timer = null; } }

  /* ---------- Поля для кода ---------- */

  function setupDigits() {
    els.digits.forEach(function (input, idx) {
      input.addEventListener('input', function () {
        var v = input.value.replace(/\D/g, '');
        if (v.length > 1) {
          // вставка или автоподстановка кода из SMS
          v.slice(0, 6).split('').forEach(function (ch, i) { if (els.digits[i]) els.digits[i].value = ch; });
          var last = Math.min(v.length, 6) - 1;
          els.digits[last].focus(FS);
        } else {
          input.value = v;
          if (v && els.digits[idx + 1]) els.digits[idx + 1].focus(FS);
        }
        els.steps.code.querySelector('[data-code]').classList.remove('has-error');
        if (codeValue().length === 6) verify(els.steps.code.querySelector('[data-act="verify"]'));
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Backspace' && !input.value && els.digits[idx - 1]) { els.digits[idx - 1].focus(FS); els.digits[idx - 1].value = ''; }
        if (e.key === 'ArrowLeft' && els.digits[idx - 1]) els.digits[idx - 1].focus(FS);
        if (e.key === 'ArrowRight' && els.digits[idx + 1]) els.digits[idx + 1].focus(FS);
      });
      input.addEventListener('focus', function () { input.select(); });
    });
  }

  if (openBtn) openBtn.addEventListener('click', open);
})();
